import { dispatch, dispatchBatch } from './cms_view_datastore';
import { cmsTechNewFinding } from './cms_tech';
import { Map, View, Overlay, Projection, VectorLayer, VectorSource, GeoJSON, Style, Stroke, Fill, Text, getCenter } from '../src/ts/openlayers/ol-bridge';
import { KEY_DRAWING_P1P2, KEY_ID_FLOOR, KEY_STATE_ADD_WORKORDER, KEY_STATE_ADD_ASSET, KEY_STATE_ADD_FINDING, KEY_STATE_UI_CREATEATTACHMENT_GET_COORD, KEY_STATE_SITEMAP_AVAILABLE, KEY_STATE_IS_PAGE_CURRENTLY_SITEMAP, getJSBool } from './cms_view_datastore';
import { immState, getJSArray } from './cms_view_datastore';

export var _mapLayers = {};
_mapLayers.assets = {};
_mapLayers.workorders = {};
_mapLayers.debug = {};  // debug layer containing P1/P2 markers
_mapLayers.attachments = {};  // map layer containing attachments markers
_mapLayers.geoJson = {}; // map layer containing geojson for sitemap
_mapLayers.pushpin = {}; // map layer for pushpin coordinates

export const SITEMAP_LAYER_ID = "sitemap_layer";

//var map = new ol.Map({})


export var settings = {
    width: 16384,
    height: 16384,
    minZoom: 0,
    maxZoom: 6,
    tileSize: 256,
    maxResolution: 16,
    minResolution: 0.25,
    initialZoom: 1,
}

settings.extent = [0, 0, settings.width, settings.height]

settings.projection = new Projection({
    code: null,
    units: "pixels",
    extent: settings.extent
});


// misc constants
var __sitemap_text = 'bold 16px Calibri,sans-serif'




export var view = new View({
    center: getCenter(settings.extent),
    zoom: settings.initialZoom,
    projection: settings.projection,
    minZoom: settings.minZoom,
    maxZoom: settings.maxZoom,
    extent: [0,0,settings.width, settings.height],
    constrainOnlyCenter: true
})



 /** Attachments overlay */
  /**
       * Elements that make up the popup.
       */
      var attachments_container = document.getElementById('attachments-popup');
      var attachments_content = document.getElementById('view_attachment_modal_content');
      var attachments_closer = document.getElementById('attachments-popup-closer');


      /**
       * Create an overlay to anchor the popup to the map.
       */
    export var attachments_overlay = new Overlay({
        element: attachments_container,
        autoPan: true,
        autoPanAnimation: {
            duration: 250
        }
    });


      /**
       * Add a click handler to hide the popup.
       * @return {boolean} Don't follow the href.
       */
        if (attachments_closer) {
            attachments_closer.onclick = function() {
                attachments_overlay.setPosition(undefined);
                attachments_closer.blur();
                return false;
            };
        }
// map controls

var highlightStyleCache = {};

var sitemapOverlay = null;
function createsitemapOverlay(map) {

    return new VectorLayer({
        idLayer: "988",
        source: new VectorSource(),
        map: map,
        style: function (feature, resolution) {
            // console.log("in sitemapOverlay zoom?? " + map.getView().getZoom());
            // var text = '';
            // if (map.getView().getZoom() > 2)
            // {
            //     text = resolution < 5000 ? feature.get('name') + woCount: '';
            // }
            // console.log(resolution)

            var b_text = '';
            if (resolution < 32) {
                var building_id = feature.getId();
                var woCount = __get_total_workorder_count(building_id);
                b_text = feature.get('name') + woCount;
            }
            var text = b_text;
            if (!highlightStyleCache[text]) {
                highlightStyleCache[text] = new Style({
                    stroke: new Stroke({
                        color: '#000',
                        width: 2
                    }),
                    fill: new Fill({
                        color: 'rgba(0,155,139,0.8)'
                    }),
                    text: new Text({
                        font: __sitemap_text,
                        text: text,
                        fill: new Fill({
                            color: '#000'
                        }),
                        stroke: new Stroke({
                            color: '#009b8b',
                            width: 3
                        })
                    })
                });
            }
            return highlightStyleCache[text];
        }
    });
}

function __get_total_workorder_count(building_id){
    var count = 0;
    var building_wo_count =immState().get(KEY_BUILDING_WO_COUNT).toJS();
    if (Object.keys(building_wo_count).length > 0) {
        if (building_wo_count.hasOwnProperty(building_id)) {
            for (var id in building_wo_count) {
                if (building_id == id) {
                    count = building_wo_count[id];
                    break;
                }
            }
        }

    }
    var rtnVal = '';

    if (count > 1)
    {
        rtnVal = ' (' + count + ' WOs)';
    }
    if (count == 1) {
        rtnVal = ' (' + count + ' WO)';
    }
    return rtnVal;
}

// map events

var highlight;
function hilight_building(pixel, map) {

    var feature = map.forEachFeatureAtPixel(pixel, function(feature) {
        return feature;
    });

    if (feature !== highlight) {
        if (highlight) {
            sitemapOverlay.getSource().removeFeature(highlight);
        }
        if (feature) {
            sitemapOverlay.getSource().addFeature(feature);
        }
        highlight = feature;
    }

};

function log_map_feature_info(pixel) {
    var feature = map.forEachFeatureAtPixel(pixel, function(feature, layer) {
        return feature;
    });
    if (feature) {
        if(feature.data)
        {
            if(feature.data.id_asset){
                console.log(`Asset: ${feature.data.id_asset}`)
            }
            else if(feature.data.id_attachment){
                console.log(`Attachment: ${feature.data.id_attachment}`)
            }
            else {
                console.log(`???: ${feature.data}`)
            }
        }
    }
}


function openUrl (pixel, map) {
    var feature = map.forEachFeatureAtPixel(pixel, function(feature) {
        return feature;
    });
    if (feature) {
        var id_building = feature.getId();
        console.log("id_building " + id_building);
        var id_floor = feature.get('id_floor');
        dispatch(ACTION_SET_ID_BUILDING, id_building);
        if(highlight){
            sitemapOverlay.getSource().removeFeature(highlight);
        }
    }
};

export function get_map_layer_by_id(map_object, id_layer) {

    var rtnVal = null;

    map_object.getLayers().forEach(function(layer, index){
        var temp=layer.get("idLayer")
        if (temp)
        {
            if (temp===id_layer)
            {
                rtnVal = layer;
            }
        }
    });
    return rtnVal;
}

function get_map_overlay_by_id(map_object, id_overlay) {

    var rtnVal = null;

    map_object.getOverlays().forEach(function(layer, index){
        var temp=layer.get("idLayer")
        if (temp)
        {
            if (temp===id_overlay)
            {
                rtnVal = layer;
            }
        }
    });
    return rtnVal;
}


export function OnMapDoubleClick(event){
    var state = immState();
    var coord = event.coordinate  // get the event.coordinate, not the event.pixel!!
    var drawing_p1p2 =  getJSArray(state, KEY_DRAWING_P1P2, null)  // awh todo: if a page has no p1p2, we can't really create aything on it. Catch this when the drawings are loaded
    var id_floor = state.get(KEY_ID_FLOOR)
    var handled = false

    if (immState().get(KEY_STATE_ADD_WORKORDER) == true) {
        console.log("adding a workorder on floor " + id_floor + " at - " + coord)
        cmsTechNewWorkOrder(id_floor, coord, drawing_p1p2)
        dispatch(ACTION_SET_ADD_WORKORDER_STATE, false)  // The new workorder is being set. Exit the workorder set state.
        handled = true
        event.preventDefault();  // We are in an add feature state. Do not do the default double click event (normally it's a zoom)

    }
    if (immState().get(KEY_STATE_ADD_ASSET) == true) {
        console.log("adding an asset on floor " + id_floor + " at - " + coord)
        cmsTechNewAsset(id_floor, coord, drawing_p1p2)
        dispatch( ACTION_SET_ADD_ASSET_STATE, false) // The new asset is being set. Exit the asset set state.
        handled = true
        event.preventDefault();  // We are in an add feature state. Do not do the default double click event (normally it's a zoom)
    }
    if (immState().get(KEY_STATE_ADD_FINDING) == true) {
        console.log("adding a finding on floor " + id_floor + " at - " + coord)
        cmsTechNewFinding(id_floor, coord, drawing_p1p2)
        dispatch(ts_temp__actions.SET_ADD_FINDINGS_STATE, false) // The new finding is being set. Exit the asset set state.
        handled = true
        event.preventDefault();  // We are in an add feature state. Do not do the default double click event (normally it's a zoom)
    }
    if (getJSBool(state, KEY_STATE_UI_CREATEATTACHMENT_GET_COORD)) {
        var attachment_type = "";
        if (state.get(KEY_ATTACHMENT_TYPE)) {
            attachment_type = state.get(KEY_ATTACHMENT_TYPE);
        }
        console.log("adding an attachment " + attachment_type + " on floor " + id_floor + " at - " + coord);
        var add_attachment_object = {
            'id_location' : id_floor,
            'p1p2' : drawing_p1p2,
            'coord' : coord,
            'file_extension' : '',
            'file_base64' : '',
            'attachment_type' : attachment_type,
            'url' : ''
        }

        dispatchBatch([
            [ACTION_SET_ADD_ATTACHMENT_OBJECT, add_attachment_object],
            [ACTION_UI_CREATEATTACHMENT_GET_COORD_STOP, null]
        ]);
        if (window.File && window.FileReader && window.FileList && window.Blob) {
            if (attachment_type ==='image'){
                dispatch(ACTION_UI_CREATEATTACHMENT_GET_FILE_START, null) // The new attachment is set. Exit the attachment set state.
                dispatch(ACTION_SET_ADD_ATTACHMENT_STATE, VALUE_CREATING_ATTACHMENT_GETTING_FILE) // The new attachment is set. Exit the attachment set state.
            }
            else {
                dispatch(ACTION_UI_CREATEATTACHMENT_GET_LINK_START, null)
                dispatch(ACTION_SET_ADD_ATTACHMENT_STATE, ts_temp__state_values.STATE_CREATING_ATTACHMENT_GETTING_URL)
            }
        } else {
            alert('Cannot Add attachment. The File APIs are not fully supported in this browser.');  // awh todo: catch this on page load and disable the add attachemnt menu item.
            dispatch(ACTION_SET_ADD_ATTACHMENT_STATE, VALUE_CREATING_ATTACHMENT_VOID) // The new attachment is set. Exit the attachment set state.
        }
        handled = true
        event.preventDefault();  // We are in an add feature state. Do not do the default double click event (normally it's a zoom)
    }

    if (getJSBool(state, ts_temp__keys.KEY_STATE_UI_CREATEPUSHPIN_GET_COORD)) {

        console.log("adding a pushpin " + " on floor " + id_floor + " at - " + coord);

        dispatchBatch([
            [ts_temp__actions.ACTION_SET_PUSHPIN_COORD, coord],
            [ts_temp__actions.ACTION_SET_PUSHPIN_GET_COORD_STOP, null]
        ]);
        handled = true
        event.preventDefault();  // We are in an add feature state. Do not do the default double click event (normally it's a zoom)
    }

    if (handled) {
        if (event.stopPropagation) {
            event.stopPropagation();
        }
        return false;
    }

}

function build_sitemap_layer() {
    var state = immState();
    var avail = getJSBool(immState(), KEY_STATE_SITEMAP_AVAILABLE);
    var current = getJSBool(immState(), KEY_STATE_IS_PAGE_CURRENTLY_SITEMAP);
    var rtnVal = null;
    var style = new Style({
        fill: new Fill({
            color: 'rgba(255, 255, 255, 0.6)'
        }),
        stroke: new Stroke({
            color: '#319FD3',
            width: 3
        }),
        text: new Text({
            font: __sitemap_text,
            fill: new Fill({
                color: '#000'
            }),
            stroke: new Stroke({
                color: '#fff',
                width: 3
            })
        })
    });
    if (avail === true)
    {
         if (current === true)
         {
            var sitemap_layer = new VectorLayer({
                idLayer: SITEMAP_LAYER_ID,
                source: new VectorSource({
                    url: state.get(KEY_SITEMAP_GEOJSON),
                    format: new GeoJSON()
                }),
                style: function(feature, resolution) {
                    // console.log("in build_sitemap_layer zoom?? " + map.getView().getZoom());
                    // if (map.getView().getZoom() > 2)
                    // {
                    //     style.getText().setText(resolution < 5000 ? feature.get('name') + woCount: '');
                    // }
                    // var building_id = feature.getId();
                    // var woCount = __get_total_workorder_count(building_id);
                    // style.getText().setText(resolution < 32 ? feature.get('name') + woCount: '');
                    var b_text = '';
                    if (resolution < 32) {
                        var building_id = feature.getId();
                        var woCount = __get_total_workorder_count(building_id);
                        b_text = feature.get('name') + woCount;
                    }
                    style.getText().setText(b_text);

                    return style;
                }
            });
            rtnVal = sitemap_layer;
        }

    }
    return rtnVal;
}


// WEBPACK FOOTER //
// ./js/cms_view_map.js